// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qESmV","index":"styles_index__3j2zd"};